import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  TextField,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import { GetUniversityAction } from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateCatalogService,
  EditCatalogService,
} from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { UploadFileService } from "../../Redux/service/FileService";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const AddCatalogueBrochurePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const childRef = useRef(null);

  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);

  const [prefieldData, setPrefieldData] = useState();

  const [Universitylist, setUniversitylist] = useState([]);
  const [formLoading, setFormLoading] = useState(false);

  const EditCatalogdataState = useSelector(
    (state) => state.setting?.catalog?.data?.data
  );
  //(EditCatalogdataState);
  useEffect(() => {
    setPrefieldData(
      EditCatalogdataState?.filter((data) => data._id === id)?.[0]
    );
  }, [Edit, EditCatalogdataState, id]);

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetUniversityAction(data));
  }, []);

  useEffect(() => {
    const updatedData = UniversitylistState?.map(({ name, ...rest }) => ({
      title: name,
      ...rest,
    }));
    setUniversitylist(updatedData);
  }, [UniversitylistState]);

  const validationSchema = Yup.object({
    university: Yup.string().required(
      "University for catalog/brochure is required"
    ),
    documents: Yup.array().required(
      "Document for catalog/brochure is required"
    ),
  });

  if (!prefieldData && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }

  return (
    <>
      <div className="d-flex align-items-center">
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          fontSize={fontSize.h2.small}
        >
          Settings
        </Typography>
        <Typography
          className="px-2 pt-1"
          fontFamily={FontFamily.Poppins}
          fontSize={fontSize.h4.medium}
          fontWeight={fontWeight.W300}
          color={ThemeColor.GREY}
        >
          {!Edit ? "Create" : "Edit"} Catalog/Brochure
        </Typography>
      </div>
      <div className="container">
        <Formik
          initialValues={{
            university: Edit ? prefieldData?.university?._id : "",
            documents: Edit ? prefieldData?.fileIds : [],
          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { ressetForm }) => {
            setFormLoading(true);
            //("Form data:", values);
            if (!Edit) {
              await CreateCatalogService(values)
                .then((res) => {
                  if (res.status === 200) {
                    // //(res);
                    setFormLoading(false);

                    dispatch(showSnackbar(res.data.message, "success"));
                    navigate("/CAE/CatalogueBrochureList");
                    ressetForm();
                  }
                })
                .catch((e) => {
                  setFormLoading(false);
                  dispatch(showSnackbar(apiErrorMessage(e), "error"));
                });
            } else {
              //(values,id,"for edit")
              await EditCatalogService(values, id)
                .then((res) => {
                  if (res.status === 200) {
                    // //(res);
                    setFormLoading(false);

                    dispatch(showSnackbar(res.data.message, "success"));
                    navigate("/CAE/CatalogueBrochureList");
                    ressetForm();
                  }
                })
                .catch((e) => {
                  setFormLoading(false);
                  dispatch(showSnackbar(apiErrorMessage(e), "error"));
                });
            }
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Form
              className="d-flex justify-content-center"
              onSubmit={handleSubmit}
            >
              <Box
                className="addcatalog-container"
                sx={{
                  width: { sm: "100%", xs: "100%", md: "80%", lg: "80%" },
                }}
              >
                <Typography
                  align="center"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h3.medium}
                  color={ThemeColor.PURPLE}
                >
                  {!Edit ? "Add" : "Edit"} Catalog / Brochure
                </Typography>
                <FormGroup style={{}}>
                  <div className="">
                    <Typography
                      className="mb-2"
                      sx={{
                        fontWeight: 520,
                        fontSize: "0.9rem",
                        letterSpacing: "0.00938em",
                        fontFamily: "Lato !important",
                      }}
                    >
                      Name of the University
                    </Typography>
                    <CustomSelect
                      value={Universitylist ? values.university : null}
                      name={"university"}
                      multiple={false}
                      option={Universitylist}
                      onChange={(e) =>
                        setFieldValue("university", e.target.value)
                      }
                      fullWidth={true}
                      // label={"Select name of university"}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.university}
                        </Typography>
                      }
                    />
                  </div>
                </FormGroup>

                <div className="w-100 d-flex justify-content-center mt-4">
                  <Previews
                    initialValue={values.documents}
                    ref={childRef}
                    deleteShow={
                      window.sessionStorage.getItem("user_role_type") ===
                        "agent"
                        ? false
                        : true
                    }
                    handleMydropzoneFile={(updatedFiles) => {
                      //(updatedFiles, "oooyesah");
                      setFieldValue("documents", updatedFiles);
                    }}
                    helperText={
                      <Typography
                        align="left"
                        // className="px-3"
                        color={ThemeColor.RED}
                        fontSize={fontSize.h4.medium}
                        fontFamily={FontFamily.Lato}
                        fontWeight={fontWeight.W500}
                      >
                        {errors.documents}
                      </Typography>
                    }
                  />
                </div>
                {(!window.sessionStorage.getItem("user_role_type") ===
                  "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") ===
                  "user") && (
                    <Box
                      sx={{
                        flexDirection: {
                          lg: "row",
                          md: "row",
                          sm: "column",
                          xs: "column",
                        },
                      }}
                      className="d-flex justify-content-center align-items-center h-100 w-100 mt-3"
                    >
                      {" "}
                      <CustomButton
                        variant="contained"
                        type="submit"
                        backgroundColor={ThemeColor.PURPLE}
                        color={ThemeColor.WHITE}
                        loading={formLoading}
                      //   padding={"0px"}
                      // onClick={handleClick}
                      >
                        {!Edit ? "Save Catalog/Brochure" : "Save Changes"}
                      </CustomButton>
                      <Box
                        className="px-2"
                        sx={{
                          paddingTop: {
                            lg: "0px",
                            md: "0px",
                            sm: "5px",
                            xs: "5px",
                          },
                        }}
                      >
                        {Edit && (
                          <CustomButton
                            variant="contained"
                            // type="submit"
                            backgroundColor={ThemeColor.RED}
                            color={ThemeColor.WHITE}
                            loading={formLoading}
                            //   padding={"0px"}
                            onClick={() => {
                              // setFieldValue('birthday', null);
                              // if (childRef.current) {
                              //   childRef.current.someFunction();
                              // }
                              if (!Edit) {
                                if (childRef.current) {
                                  childRef.current.someFunction();
                                }
                              } else {
                                if (childRef.current) {
                                  childRef.current.someEditFunction();
                                }
                              }
                              // setFieldValue("documents", []);
                              // //(values)
                              resetForm();
                            }}
                          >
                            Cancel Changes
                          </CustomButton>
                        )}
                      </Box>
                    </Box>
                  )}
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

function AddCatalogueBrochure() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<AddCatalogueBrochurePage />} />
    </div>
  );
}

export default AddCatalogueBrochure;
